module.exports = __webpack_public_path__ + "static/media/donor_report.ad97b0d2.png";